/**
 * Gujarati (ગુજરાતી) translations
 */
import { TranslationStrings } from '../types';

export const gu: TranslationStrings = {  common: {
    loading: 'લોડ થઈ રહ્યું છે...',
    error: 'એક ભૂલ આવી',
    retry: 'ફરી પ્રયાસ કરો',
    cancel: 'રદ કરો',
    confirm: 'પુષ્ટિ કરો',
    back: 'પાછળ',
    next: 'આગળ',
    submit: 'સબમિટ કરો',
    done: 'થઈ ગયું',
    close: 'બંધ કરો',
    yes: 'હા',
    no: 'ના',
    required: 'જરૂરી',
    optional: 'વૈકલ્પિક',
  },
  consent: {
    secureConsent: 'સુરક્ષિત સંમતિ',
    yourConsentRequired: 'તમારી સંમતિ જરૂરી છે',
    consentingAs: 'તરીકે સંમતિ આપી રહ્યા છે',
    requestingOrg: 'વિનંતી કરનાર સંસ્થા',
    dataBeingCollected: 'એકત્રિત થઈ રહેલો ડેટા',
    purposeOfProcessing: 'પ્રોસેસિંગનો હેતુ',
    whatYouWillDo: 'તમે શું કરશો',
    reviewDocuments: 'દસ્તાવેજોની સમીક્ષા કરો',
    provideConsent: 'સંમતિ આપો',
    documentsToRead: 'વાંચવાના દસ્તાવેજો',
    estimatedTime: 'અંદાજિત સમય',
    minutes: 'મિનિટ',
    startReview: 'સમીક્ષા શરૂ કરો',
    yourRights: 'DPDP કાયદો 2023 હેઠળ તમારા અધિકારો',
    rightToAccess: 'તમારો ડેટા ઍક્સેસ કરવાનો અધિકાર',
    rightToCorrect: 'તમારો ડેટા સુધારવાનો અધિકાર',
    rightToWithdraw: 'સંમતિ પાછી ખેંચવાનો અધિકાર',
    rightToGrievance: 'ફરિયાદ નોંધાવવાનો અધિકાર',
    stepOf: 'પગલું {current} / {total}',
    pleaseReadCarefully: 'કૃપા કરીને સંમતિ આપતા પહેલા દરેક દસ્તાવેજ કાળજીપૂર્વક વાંચો.',
    documentsReviewed: 'સમીક્ષા કરેલ દસ્તાવેજો',
    remaining: 'બાકી',
    allDocumentsReviewed: 'બધા દસ્તાવેજોની સમીક્ષા થઈ ગઈ!',
    clickToRead: 'વાંચવા માટે દરેક દસ્તાવેજ પર ક્લિક કરો',
    proceedToConsent: 'તમે સંમતિ આપવા આગળ વધી શકો છો',
    markAsRead: 'વાંચ્યું તરીકે ચિહ્નિત કરો',
    continueReading: 'વાંચવાનું ચાલુ રાખો',
    confirmConsent: 'તમારી સંમતિની પુષ્ટિ કરો',
    selectMethod: 'ચકાસણી પદ્ધતિ પસંદ કરો',
    iAgreeToTerms: 'હું બધી શરતો, નીતિઓ અને સંમતિ કરારો સાથે સંમત છું',
    readAllDocuments: 'હું સમજું છું કે મારી સંમતિ સ્વૈચ્છિક છે અને કોઈપણ સમયે પાછી ખેંચી શકાય છે',
    submitConsent: 'સંમતિ સબમિટ કરો',
    submitting: 'સબમિટ થઈ રહ્યું છે...',
    digitalSignature: 'ડિજિટલ સહી',
    smsVerification: 'SMS ચકાસણી',
    emailVerification: 'ઈમેલ ચકાસણી',
    videoRecording: 'વીડિયો રેકોર્ડિંગ',
    audioRecording: 'ઓડિયો રેકોર્ડિંગ',
    checkboxConfirmation: 'ચેકબોક્સ પુષ્ટિ',
    drawSignature: 'તમારી સહી દોરો',
    verifyViaSms: 'SMS કોડ દ્વારા ચકાસો',
    verifyViaEmail: 'ઈમેલ કોડ દ્વારા ચકાસો',
    recordVideoConsent: 'વીડિયો સંમતિ રેકોર્ડ કરો',
    recordAudioConsent: 'ઓડિયો સંમતિ રેકોર્ડ કરો',
    confirmByChecking: 'ચેક કરીને પુષ્ટિ કરો',
    enterOtp: 'OTP દાખલ કરો',
    otpSentTo: 'OTP મોકલવામાં આવ્યો',
    resendOtp: 'OTP ફરી મોકલો',
    verifyOtp: 'OTP ચકાસો',
    otpVerified: 'OTP ચકાસાયો',
    invalidOtp: 'અમાન્ય OTP',
    startRecording: 'રેકોર્ડિંગ શરૂ કરો',
    stopRecording: 'રેકોર્ડિંગ બંધ કરો',
    retake: 'ફરી લો',
    recordingComplete: 'રેકોર્ડિંગ પૂર્ણ',
    consentSubmitted: 'સંમતિ સફળતાપૂર્વક સબમિટ થઈ',
    thankYou: 'સંમતિ આપવા બદલ આભાર',
    confirmationSent: 'તમારા ઈમેલ પર પુષ્ટિ મોકલવામાં આવી છે',
    referenceNumber: 'સંદર્ભ નંબર',
    errorSubmitting: 'સંમતિ સબમિટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.',
    pleaseReadDocs: 'કૃપા કરીને પહેલા બધા દસ્તાવેજો વાંચો',
    pleaseProvideEvidence: 'કૃપા કરીને સંમતિનો પુરાવો આપો',
  },
  documents: {
    privacyPolicy: 'ગોપનીયતા નીતિ',
    termsOfService: 'સેવાની શરતો',
    consentAgreement: 'સંમતિ',
    dataSharingAgreement: 'ડેટા શેરિંગ કરાર',
    cookiePolicy: 'કૂકી નીતિ',
    retentionPolicy: 'ડેટા રીટેન્શન નીતિ',
    gdprNotice: 'GDPR નોટિસ',
    hipaaAuthorization: 'HIPAA અધિકૃતતા',
    ccpaDisclosure: 'CCPA જાહેરાત',
    aadhaarAuthorization: 'આધાર અધિકૃતતા',
    customDocument: 'કસ્ટમ દસ્તાવેજ',
  },
  dataCategories: {
    personalInfo: 'વ્યક્તિગત માહિતી',
    contactDetails: 'સંપર્ક વિગતો',
    financialInfo: 'નાણાકીય માહિતી',
    healthData: 'આરોગ્ય અને તબીબી ડેટા',
    biometricData: 'બાયોમેટ્રિક ડેટા',
    locationData: 'સ્થાન ડેટા',
    behavioralData: 'વર્તણૂક ડેટા',
    communicationData: 'સંચાર ડેટા',
    employmentInfo: 'રોજગાર માહિતી',
    educationInfo: 'શૈક્ષણિક માહિતી',
  },
  a11y: {
    mainContent: 'મુખ્ય સામગ્રી',
    navigation: 'નેવિગેશન',
    closeModal: 'મોડલ બંધ કરો',
    expandSection: 'વિભાગ વિસ્તારો',
    collapseSection: 'વિભાગ સંકોચો',
    documentRead: 'દસ્તાવેજ વાંચ્યું તરીકે ચિહ્નિત',
    documentUnread: 'દસ્તાવેજ હજુ વાંચ્યું નથી',
    progressIndicator: 'પ્રગતિ: {current} / {total} દસ્તાવેજો વાંચ્યા',
    signaturePad: 'સહી વિસ્તાર',
    clearSignature: 'સહી સાફ કરો',
    videoPlayer: 'વીડિયો રેકોર્ડિંગ પ્લેયર',
    audioPlayer: 'ઓડિયો રેકોર્ડિંગ પ્લેયર',
    requiredField: 'આ ફીલ્ડ જરૂરી છે',
    errorMessage: 'ભૂલ',
    successMessage: 'સફળતા',
    loadingContent: 'સામગ્રી લોડ થઈ રહી છે, કૃપા કરીને રાહ જુઓ',
    newWindow: 'નવી વિન્ડોમાં ખૂલે છે',
  },
  portal: {
    // General
    myConsents: 'મારી સંમતિઓ',
    viewManageConsents: 'તમારા સંમતિ રેકોર્ડ જુઓ અને મેનેજ કરો',
    logout: 'લૉગઆઉટ',
    welcomeBack: 'પાછા આવવા બદલ સ્વાગત',
    
    // Tenant selector
    organizationNameOrCode: 'સંસ્થાનું નામ અથવા કોડ',
    orgPlaceholder: 'દા.ત., globalhealth અથવા acme-corp',
    orgHint: 'તમારી સંસ્થા દ્વારા આપેલ નામ અથવા કોડ દાખલ કરો',
    findMyOrganization: 'મારી સંસ્થા શોધો',
    orgNotFound: 'સંસ્થા મળી નથી. કૃપા કરીને નામ તપાસો અને ફરી પ્રયાસ કરો.',
    enterOrgName: 'કૃપા કરીને તમારી સંસ્થાનું નામ અથવા કોડ દાખલ કરો',
    or: 'અથવા',
    haveDirectLink: 'તમારી સંસ્થા તરફથી સીધી લિંક છે?',
    useDirectLink: 'તેમણે આપેલી લિંકનો ઉપયોગ કરો',
    privacyProtected: 'તમારી ગોપનીયતા કાયદા દ્વારા સુરક્ષિત છે',
    
    // Login flow
    phoneOrEmail: 'ફોન નંબર અથવા ઈમેલ',
    enterPhoneOrEmailPlaceholder: 'તમારો નોંધણીકૃત ફોન અથવા ઈમેલ દાખલ કરો',
    otpWillBeSent: 'અમે તમને વન-ટાઈમ પાસવર્ડ (OTP) મોકલીશું',
    sendOtp: 'OTP મોકલો',
    enterPhoneOrEmail: 'કૃપા કરીને તમારો ફોન નંબર અથવા ઈમેલ દાખલ કરો',
    otpSentTo: 'OTP મોકલાયો',
    expiresIn: 'સમાપ્ત થશે',
    enterOtp: 'OTP દાખલ કરો',
    enterValidOtp: 'કૃપા કરીને માન્ય OTP દાખલ કરો',
    verifyOtp: 'OTP ચકાસો',
    resendOtp: 'OTP ફરી મોકલો',
    otpVerified: 'OTP ચકાસાયો',
    oneMoreStep: 'તમારી ઓળખ ચકાસવા માટે એક વધુ પગલું',
    enterSecurityAnswer: 'કૃપા કરીને તમારો જવાબ દાખલ કરો',
    enterAnswer: 'જવાબ દાખલ કરો',
    dobFormat: 'ફોર્મેટ: DDMMYYYY (દા.ત., 15051990 મે 15, 1990)',
    login: 'લૉગિન',
    startOver: 'ફરીથી શરૂ કરો',
    needHelp: 'મદદ જોઈએ?',
    privacyNotice: 'તમારો ડેટા લાગુ ગોપનીયતા કાયદાઓ હેઠળ સુરક્ષિત છે',
    checkUrlOrContact: 'કૃપા કરીને URL તપાસો અથવા તમારી સંસ્થાનો સંપર્ક કરો.',
    
    // Consent history
    filterAll: 'બધા',
    statusActive: 'સક્રિય',
    statusWithdrawn: 'પાછા ખેંચાયા',
    statusExpired: 'સમાપ્ત',
    noConsents: 'કોઈ સંમતિ રેકોર્ડ મળ્યા નથી',
    noConsentsWithFilter: 'આ સ્થિતિમાં કોઈ સંમતિ નથી',
    consentedOn: 'સંમતિ આપી',
    expiresOn: 'સમાપ્ત થશે',
    withdrawnOn: 'પાછા ખેંચાયા',
    withdrawConsent: 'સંમતિ પાછી ખેંચો',
    withdrawalHistory: 'પાછા ખેંચવાનો ઇતિહાસ',
    help: 'મદદ',
    
    // Withdrawal
    cannotWithdraw: 'આ સંમતિ પાછી ખેંચી શકાતી નથી',
    pleaseConfirmWithdrawal: 'કૃપા કરીને પુષ્ટિ કરો કે તમે પરિણામો સમજો છો',
    importantNotice: 'મહત્વની સૂચના',
    withdrawalNotice1: 'સંસ્થા જણાવેલ હેતુઓ માટે તમારો ડેટા પ્રોસેસ કરવાનું બંધ કરશે.',
    withdrawalNotice2: 'કાનૂની અનુપાલન માટે કેટલોક ડેટા રાખવામાં આવી શકે છે.',
    withdrawalNotice3: 'કેટલીક સેવાઓનો ઉપયોગ કરવા માટે તમારે ફરીથી સંમતિ આપવી પડી શકે છે.',
    withdrawalNotice4: 'લાગુ કાયદાઓના આધારે પ્રોસેસિંગ સમય 7-30 દિવસ લાગી શકે છે.',
    withdrawalReason: 'પાછા ખેંચવાનું કારણ',
    withdrawalReasonPlaceholder: 'તમે શા માટે પાછા ખેંચવા માગો છો તે જણાવો (વૈકલ્પિક)',
    withdrawalConfirmation: 'હું સમજું છું કે મારી સંમતિ પાછી ખેંચવાથી કેટલીક સેવાઓનો ઉપયોગ કરવાની મારી ક્ષમતા પર અસર થઈ શકે છે, અને હું આ વિનંતી સાથે આગળ વધવા ઈચ્છું છું.',
    submitWithdrawalRequest: 'પાછા ખેંચવાની વિનંતી સબમિટ કરો',
    withdrawalSubmitted: 'પાછા ખેંચવાની વિનંતી સબમિટ થઈ',
    withdrawalSubmittedDesc: 'તમારી પાછા ખેંચવાની વિનંતી સબમિટ થઈ છે. સંસ્થા પ્રોસેસ કર્યા પછી તમને જણાવવામાં આવશે.',
    processingTime: 'પ્રોસેસિંગ સમય',
    days: 'દિવસો',
    backToHistory: 'સંમતિ ઇતિહાસ પર પાછા જાઓ',
    
    // Withdrawal history
    statusPending: 'બાકી',
    statusApproved: 'મંજૂર',
    statusRejected: 'નકાર્યું',
    noWithdrawals: 'કોઈ પાછા ખેંચવાની વિનંતી નથી',
    viewConsents: 'તમારી સંમતિઓ જુઓ',
    requestedOn: 'વિનંતી કરી',
    processedOn: 'પ્રોસેસ કર્યું',
    processingMessage: 'તમારી વિનંતી પ્રોસેસ થઈ રહી છે. પૂર્ણ થયા પછી તમને જણાવવામાં આવશે.',
    processingTimeInfo: 'પ્રોસેસિંગ સમય માહિતી',
    
    // Help section
    yourRights: 'તમારા ગોપનીયતા અધિકારો',
    helpTitle: 'તમારા ગોપનીયતા અધિકારો સમજો',
    helpSubtitle: 'ગોપનીયતા કાયદાઓ હેઠળ તમારા અધિકારો અને સંમતિ કેવી રીતે મેનેજ કરવી તે જાણો.',
    quickActions: 'ઝડપી ક્રિયાઓ',
    viewMyConsents: 'મારી સંમતિઓ જુઓ',
    viewWithdrawalRequests: 'પાછા ખેંચવાની વિનંતીઓ જુઓ',
    loginToViewConsents: 'તમારી સંમતિઓ જોવા માટે લૉગિન કરો',
    applicableLaws: 'લાગુ ગોપનીયતા કાયદાઓ',
    
    // Rights FAQ
    rightAccessQ: 'એક્સેસ અધિકાર શું છે?',
    rightAccessA: 'તમારા વિશે કયો વ્યક્તિગત ડેટા એકત્ર કરવામાં આવી રહ્યો છે, તેનો ઉપયોગ કેવી રીતે થઈ રહ્યો છે, કોની સાથે શેર કરવામાં આવી રહ્યો છે તે જાણવાનો તમને અધિકાર છે.',
    rightCorrectQ: 'સુધારણા અધિકાર શું છે?',
    rightCorrectA: 'જો તમારો વ્યક્તિગત ડેટા ખોટો અથવા અધૂરો હોય, તો તમે તેને સુધારવા અથવા અપડેટ કરવાની વિનંતી કરી શકો છો.',
    rightWithdrawQ: 'સંમતિ પાછી ખેંચવાનો અધિકાર શું છે?',
    rightWithdrawA: 'તમે કોઈપણ સમયે તમારી સંમતિ પાછી ખેંચી શકો છો. પાછી ખેંચ્યા પછી, તમે જે હેતુઓ માટે સંમતિ આપી હતી તે માટે તમારો ડેટા પ્રોસેસ કરવાનું સંસ્થાએ બંધ કરવું જોઈએ.',
    rightEraseQ: 'ભૂંસી નાખવાનો અધિકાર શું છે?',
    rightEraseA: '"ભૂલાઈ જવાનો અધિકાર" તરીકે પણ ઓળખાય છે, તમે તમારો વ્યક્તિગત ડેટા કાઢી નાખવાની વિનંતી કરી શકો છો. જોકે, કેટલીક માહિતી રાખવા માટે કાનૂની કારણો હોઈ શકે છે.',
    
    // Withdrawal FAQ
    withdrawalFaq: 'પાછા ખેંચવાની પ્રક્રિયા',
    withdrawHowQ: 'મારી સંમતિ કેવી રીતે પાછી ખેંચવી?',
    withdrawHowA: 'તમારા એકાઉન્ટમાં લૉગિન કરો, સંમતિ ઇતિહાસ પર જાઓ, સક્રિય સંમતિ પર "સંમતિ પાછી ખેંચો" ક્લિક કરો.',
    withdrawTimeQ: 'પાછા ખેંચવામાં કેટલો સમય લાગે છે?',
    withdrawTimeA: 'લાગુ કાયદાઓના આધારે પ્રોસેસિંગ સમય: DPDP એક્ટ (ભારત) - 7 દિવસ, GDPR (EU) - 30 દિવસ, CCPA (કેલિફોર્નિયા) - 45 દિવસ.',
    withdrawEffectQ: 'સંમતિ પાછી ખેંચ્યા પછી શું થાય છે?',
    withdrawEffectA: 'જણાવેલ હેતુઓ માટે તમારો ડેટા ઉપયોગ કરવાનું સંસ્થા બંધ કરશે. કાનૂની અનુપાલન માટે કેટલોક ડેટા રાખવામાં આવી શકે છે.',
    
    // Security FAQ
    securityFaq: 'એકાઉન્ટ સુરક્ષા',
    loginSecureQ: 'મારું લૉગિન કેવી રીતે સુરક્ષિત છે?',
    loginSecureA: 'અમે 3-પગલા ચકાસણી પ્રક્રિયાનો ઉપયોગ કરીએ છીએ: નોંધણીકૃત ફોન/ઈમેલ પર OTP, પછી સુરક્ષા પ્રશ્ન.',
    dataProtectQ: 'મારો ડેટા કેવી રીતે સુરક્ષિત છે?',
    dataProtectA: 'બધો ડેટા ટ્રાન્ઝિટ અને રેસ્ટમાં એન્ક્રિપ્ટ થયેલો છે. DPDP એક્ટ, GDPR અને અન્ય ગોપનીયતા નિયમોનું પાલન કરીએ છીએ.',
    
    // Contact FAQ
    contactFaq: 'સંપર્ક અને સપોર્ટ',
    grievanceQ: 'ફરિયાદ કેવી રીતે દાખલ કરવી?',
    grievanceA: 'સંસ્થાના ડેટા પ્રોટેક્શન ઓફિસર (DPO) અથવા ફરિયાદ અધિકારીનો સંપર્ક કરી શકો છો.',
    regulatorQ: 'નિયમનકારી અધિકારી કોણ છે?',
    regulatorA: 'ભારતમાં, ડેટા પ્રોટેક્શન બોર્ડ ગોપનીયતા ફરિયાદો સંભાળે છે. EU માં, તમારી રાષ્ટ્રીય ડેટા પ્રોટેક્શન ઓથોરિટીનો સંપર્ક કરી શકો છો.',
  },
}
;
